import { createStructuredSelector } from "reselect";
import {
    MARKETINTEL_PRICE_LIST,
    MARKETINTEL_PRICE_LIST_SUCCESS,
    MARKETINTEL_PRICE_LIST_ERROR,
    MARKETINTEL_PRICE_PAGE_SET,
    MARKETINTEL_PRICE_HEADER,
    MARKETINTEL_PRICE_SEARCH_SET,
    MARKETINTEL_PRICE_SEARCH_CHANGE,
    MARKETINTEL_PRICE_VIEW_MODAL_SET,
    MARKETINTEL_PRICE_VIEW_DATA_SET
} from "../actions";

export const NAME = 'marketintelPrice';

export const MarketintelPriceList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: MARKETINTEL_PRICE_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const MarketintelPriceListSuccess = (data) => ({
    type: MARKETINTEL_PRICE_LIST_SUCCESS,
    payload: data
});

export const MarketintelPriceListError = (error) => ({
    type: MARKETINTEL_PRICE_LIST_ERROR,
    payload: error
});

export const MarketintelPricePageSet = (data) => ({
    type: MARKETINTEL_PRICE_PAGE_SET,
    payload: data
});

export const MarketintelPriceHeader = (data) => ({
    type: MARKETINTEL_PRICE_HEADER,
    payload: data
})

export const MarketintelPriceSearchSet = (data) => ({
    type: MARKETINTEL_PRICE_SEARCH_SET,
    payload: data
});

export const MarketintelPriceSearchChangeSet = (data) => ({
    type: MARKETINTEL_PRICE_SEARCH_CHANGE,
    payload: data
});

export const MarketintelPriceViewModalSet = (data) => ({
    type: MARKETINTEL_PRICE_VIEW_MODAL_SET,
    payload: data
});

export const MarketintelPriceViewDataSet = (data) => ({
    type: MARKETINTEL_PRICE_VIEW_DATA_SET,
    payload: data
});

const marketintelPrice = (state) => state[NAME];

export const MarketintelPriceSelector = createStructuredSelector({
    marketintelPrice
})
